import {
    GETMAPPEDLIST_SUCCESS,
    GETMAPPEDLIST_FAILED,
    RESET_GETMAPPEDLIST,
    LOADING_GETMAPPEDLIST,
    NETWORK_ERROR_GETMAPPEDLIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetMappedList = () => {
    return { type: RESET_GETMAPPEDLIST };
};

const getMappedList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMAPPEDLIST });
    await adminServices
        .post("getmappedlist", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getMappedListsuccess(res.data));
                    break;
                default:
                    dispatch(getMappedListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMAPPEDLIST,
                payload: err
            });
        });
};
function getMappedListsuccess(data) {
    return {
        type: GETMAPPEDLIST_SUCCESS,
        payload: data
    };
}
function getMappedListFailed(data) {
    return {
        type: GETMAPPEDLIST_FAILED,
        payload: data
    };
}

export { resetGetMappedList, getMappedList };
